export default "/images/db69b18ea4cf0f238bf7530c0aa2b2a7.avif";